<template>
  <a-card>
    <g-master name="biodatainformacionacademica"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="evParentData"
              modalWidth="70%">
      <template slot="expandedRowRender" slot-scope="{text}">
        <template v-for="ve in master.valoresExpandidos">
          {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
        </template>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Título obtenido')">
              <a-input
                class="ant-uppercase"
                v-decorator="['degree', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Institución')">
              <a-input
                class="ant-uppercase"
                v-decorator="['institution', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Horas')">
              <a-input
                class="ant-uppercase"
                v-decorator="['hours', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha de inicio')">
              <a-date-picker style="width: 100%"
                             v-decorator="['init_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              ></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha fin')">
              <a-date-picker style="width: 100%"
                             v-decorator="['end_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              ></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Temas principales')">
              <a-input
                class="ant-uppercase"
                v-decorator="['description', { rules: [{ required: false }] }]"/>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Tipo de estudio')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_type_degree', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                        :params="id_h_dregee">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Certificado')" :has-feedback="false">
              <a-checkbox v-decorator="['certificate', {valuePropName: 'checked'}]">
              </a-checkbox>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha de expedición')">
              <a-date-picker style="width: 100%"
                             valueFormat="Y-MM-DD 00:00:00"
                             v-decorator="['issue_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              ></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Fecha de vencimiento')">
              <a-date-picker style="width: 100%"
                             valueFormat="Y-MM-DD 00:00:00"
                             v-decorator="['expiration_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"
              ></a-date-picker>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>

  </a-card>
</template>
<script>
  export default {
    data () {
      return {
        id_h_dregee: {
          h_lookup_type: 'OTROS_ESTUDIOS'
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {},
          'has-feedback': true
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado el', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado el', column: 'modified_on'}
          ],
          endpoint: 'personacademicotherstudies',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id_academic'
            },
            columns: [
              {title: 'Tipo de estudio', dataIndex: 'view_attr', sorter: true},
              {title: 'Título obtenido', dataIndex: 'degree', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'date_initial_mask', sorter: true},
              {title: 'Fecha fin', dataIndex: 'date_end_mask', sorter: true},
              {title: 'Institución', dataIndex: 'institution', sorter: true},
              {title: 'Horas', dataIndex: 'hours', sorter: true},
              {title: 'Temas principales', dataIndex: 'description', sorter: true},
              {title: 'Certificado', dataIndex: 'certificado', sorter: true},
              {title: 'Fecha de expedición', dataIndex: 'issue_date', sorter: true},
              {title: 'Fecha de vencimiento', dataIndex: 'expiration_date', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_type_degree'},
            {name: 'degree'},
            {name: 'init_date', type: 'date'},
            {name: 'end_date', type: 'date'},
            {name: 'institution'},
            {name: 'hours'},
            {name: 'description'},
            {name: 'certificate'},
            {name: 'issue_date'},
            {name: 'expiration_date'}
          ]
        }
      }
    },
    props: ['persona'],
    computed: {
      evParentData () {
        return {
          id_person: this.persona
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataIdiomaOtrosEstudiosNoFormal.vue